import { useQuery } from '@tanstack/react-query';
import { getAdminInitiativeLeads } from '../api/admin';

export const ADMIN_INITIATIVE_LEADS_QUERY_KEY = ['admin-initiative-leads'] as const;

export function useAdminInitiativeLeadsQuery() {
  return useQuery({
    queryKey: ADMIN_INITIATIVE_LEADS_QUERY_KEY,
    queryFn: getAdminInitiativeLeads,
    staleTime: 10 * 60 * 1000,
  });
}
